import { render, staticRenderFns } from "./JeecgPdfView.vue?vue&type=template&id=0c5d87b0&scoped=true&"
import script from "./JeecgPdfView.vue?vue&type=script&lang=js&"
export * from "./JeecgPdfView.vue?vue&type=script&lang=js&"
import style0 from "./JeecgPdfView.vue?vue&type=style&index=0&id=0c5d87b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d87b0",
  null
  
)

export default component.exports